import { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";

import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";

import CustomInputV2 from '../../../common/CustomInputV2';
import CustomActionButton from "../../../common/CustomActionButton";

import { AddNewEmailTemplate, SaveEmailTemplate, ParseHTMLTemplate } from "../../../redux/emailTemplate/actions";
import { delay } from "../../../utils";

function TemplatePreview(props) {
    const [htmlContent, setHTMLContent] = useState("");
    const [templateName, setTemplateName] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [templateTag, setTemplateTag] = useState("");
    const [templateVersion, setTemplateVersion] = useState("");
    const [isDefault, setIsDefault] = useState(false);

    const { list } = props.EmailTemplate;

    useEffect(() => {

        let parsedContent = props?.et?.parsed_content ? JSON.parse(props?.et?.parsed_content) : null;
        parsedContent = parsedContent ? parsedContent?.content : null;

        let content = "";
        for (let x = 0; x < parsedContent?.length; x++) {
            content += parsedContent[x]?.content;
        }

        // setHTMLContent(content || "");
        setHTMLContent(props?.et?.html_content || "");
        setTemplateName(props?.et?.name || "");
        setEmailSubject(props?.et?.email_subject || "");
        setTemplateTag(props?.et?.tag || "");
        setTemplateVersion(props?.et?.version || "");
        setIsDefault(props?.et?.is_default || false);
    }, [props?.et?.id])

    const addNewEmailTemplate = async () => {
        const res = await props.AddNewEmailTemplate({
            name: templateName,
            content: htmlContent,
            emailSubject: emailSubject,
            tag: templateTag,
            version: templateVersion,
            isDefault: isDefault,
        });

        if (res) {
            toast.success("Email Template Added Successfully");
            delay(() => {
                props.reset();
                setHTMLContent("");
                setTemplateName("");
            }, 1500)
        } else {
            toast.error("Failed to Add Email Template");
        }

        return res;
    }

    const saveNewEmailTemplate = async () => {
        const res = await props.SaveEmailTemplate({
            ...props?.et,
            name: templateName,
            html_content: htmlContent,
            email_subject: emailSubject,
            tag: templateTag,
            version: templateVersion,
            is_default: isDefault,
        });

        if (res) {
            toast.success("Email Template Updated Successfully");
            delay(() => {
                props.reset();
                setHTMLContent("");
                setTemplateName("");
            }, 1500)
        } else {
            toast.error("Failed to Update Email Template");
        }


        return res;

    }

    const isMany = list.filter(et => et?.tag == props?.et?.tag).length > 1;

    return (
        <div id="template-preview-wrapper">
            <div className="row">
                <div className="col-5 mb-4">
                    <h5>
                        Template Name
                    </h5>
                    <CustomInputV2 style={{ maxWidth: "100%" }} value={templateName} name="name" onChange={(e) => {
                        setTemplateName(e.target.value);
                    }} />
                </div>
                <div className="col-3 mb-4">
                    <h5>
                        Tag
                    </h5>
                    <CustomInputV2 readOnly={props?.et?.id ? true : false} style={{ maxWidth: "100%" }} value={templateTag} name="tag" onChange={(e) => {
                        setTemplateTag(e.target.value);
                    }} />
                </div>
                <div className="col-2 mb-4">
                    <h5>
                        Version
                    </h5>
                    <CustomInputV2 readOnly={props?.et?.id ? true : false} style={{ maxWidth: "100%" }} value={templateVersion} name="version" onChange={(e) => {
                        setTemplateVersion(e.target.value);
                    }} />
                </div>
                {/* <div className="col-2" id="tp-switch-wrapper">
                    <FormGroup>
                        <FormControlLabel required control={<Switch disabled={!isMany && props?.et?.id} checked={isDefault} onClick={() => {
                            setIsDefault(!isDefault);
                        }} />} label="Default" labelPlacement="start" />
                    </FormGroup>
                </div> */}
                <div className="col-12 mb-4">
                    <h5>
                        Subject
                    </h5>
                    <CustomInputV2 style={{ maxWidth: "100%" }} value={emailSubject} name="subject" onChange={(e) => {
                        setEmailSubject(e.target.value);
                    }} />
                </div>
                <div className="col-7">
                    <h5>
                        HTML Content
                        {/* 
                        <CustomActionButton action={async () => {
                            const res = await props.ParseHTMLTemplate(htmlContent);
                            return res?.success || false;
                        }
                        }>
                            Parse HTML
                        </CustomActionButton> */}
                    </h5>

                    <div id="tp-html-editor">

                        <AceEditor
                            focus={true}
                            placeholder="Add HTML Content Here"
                            mode="html"
                            theme="monokai"
                            name="HTML Editor"
                            onLoad={() => { }}
                            onChange={(val) => {
                                setHTMLContent(val);
                            }}
                            fontSize={14}
                            lineHeight={19}
                            showPrintMargin={true}
                            showGutter={true}
                            highlightActiveLine={true}
                            value={`${htmlContent}`}
                            setOptions={{
                                enableBasicAutocompletion: true,
                                enableLiveAutocompletion: false,
                                enableSnippets: false,
                                showLineNumbers: true,
                                tabSize: 2,
                            }} />

                        {/* <pre contentEditable={true} onInput={(e) => {
                            setHTMLContent(e.target.outerText);
                        }}>
                        </pre> */}
                    </div>
                </div>
                <div className="col-5 template-preview-wrapper">
                    <h5>
                        Preview
                    </h5>

                    <div className="preview" dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </div>

                <div className="col-12 flex-r pt-2">
                    {!props?.et && <CustomActionButton action={addNewEmailTemplate}>Add</CustomActionButton>}
                    {props?.et && <CustomActionButton action={saveNewEmailTemplate}>Save</CustomActionButton>}
                </div>
            </div>

        </div>
    );
}

const mapStateToProps = (state) => ({
    EmailTemplate: state.EmailTemplate,
})

export default connect(mapStateToProps, {
    AddNewEmailTemplate,
    SaveEmailTemplate,
    ParseHTMLTemplate,
})(TemplatePreview);
